import { useHomePageContext } from "pages/home-page/context/homepage.context";
import { useCallback } from "react";
import { toast } from "react-toastify";
import { updatePatientValues } from "services/patients";

export const useUpdatePatientData = () => {
  const {
    dispatch,
    state: { page },
  } = useHomePageContext();
  return useCallback(
    async (studypk, patientPk, submissionData) => {
      const updateResult = await updatePatientValues(patientPk, submissionData);
      if (updateResult.success) {
        toast.success(updateResult.message);
        dispatch({
          type: "UPDATE_ROW_ITEM",
          payload: { studypk, page, updatedStudyData: submissionData },
        });
        return submissionData;
      } else {
        toast.error(`Error updating patient ${patientPk}`);
        return {};
      }
    },
    [dispatch, page]
  );
};
